import "./Organizer.css"


function Organizer(prop) {

    function sortInputArr(value) {
    //console.log(prop.arr[0][value])
        let newArr = [...prop.arr].sort((a, b) => a[value].localeCompare(b[value]))
        //.log(prop.arr)
        //console.log(newArr)

        //if search use it:
        let search_bar = document.getElementById("searchSkills");
        if (search_bar.value !== "") {
            let s = (search_bar.value).toLowerCase();
            //console.log(s)
            let newBegArr = newArr.filter(str => str["name"].toLowerCase().startsWith(s));
            let newEndArr = newArr.filter(str => (!str["name"].toLowerCase().startsWith(s) && str["name"].toLowerCase().includes(s)))
            //console.log(newEndArr)
            //console.log(newBegArr)
            newArr = newBegArr.concat(newEndArr)
        }

        prop.setFunc(newArr)
    }

    function searchInputArr(e) {
        let s = (e.target.value).toLowerCase();
        //console.log(s)
        let newBegArr = prop.arr.filter(str => str["name"].toLowerCase().startsWith(s));
        let newEndArr = prop.arr.filter(str => (!str["name"].toLowerCase().startsWith(s) && str["name"].toLowerCase().includes(s)))
        //console.log(newEndArr)
        //console.log(newBegArr)
        let retVal = newBegArr.concat(newEndArr)

        prop.setFunc(retVal)
    }

    return (
        <div className="Organizer">
        {/*create custom filters*/}
        <div className="flex-container">
            <div className="filters">
                <h3> Filters</h3>
                {prop.filters.map((item) => (
                    <button key={item.name} onClick={() => sortInputArr(item.var)}>{item.name}</button>
                ))}
            </div>
            <input id="searchSkills" type="text" placeholder="Search.." onChange={(e) => searchInputArr(e)}/>

            <p>{prop.value}</p>
        </div>
        </div>

    );
}

export default Organizer;